import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CountAndResults, TwitterSorts } from '../shared/types';

@Injectable()
export class MiscService {
  private http = inject(HttpClient);


  gender(firstName: string): Observable<{ gender: string }> {
    return this.http.get<{ gender: string }>(`/api/gender/${firstName}`);
  }

  twitterTweets(username: string, sort: TwitterSorts): Observable<CountAndResults> {
    return this.http.get<CountAndResults>(`/api/twitter/tweets/${username}/${sort}`);
  }

}
